export default {
    lorem_ipsum:
        'Lorem ipsum dolor sit amet, ad dolorem fierent neglegentur eam, qui ne labores menandri scriptorem, soleat integre et eam. Nibh efficiendi vis et, ne dicta volutpat quaerendum sed, agam democritum adipiscing an pro. Quod verear nec ad. Ad diam latine patrioque per, ipsum apeirian definitionem usu cu. Enim meis aperiam vix at, aliquip singulis ius no. Ei liber quidam delicatissimi pri, quis semper denique ei mel, enim dicam an per.',

    cause_294: 'All causes',
    cause_295: 'Communicable, maternal, neonatal, and nutritional diseases',
    cause_296: 'HIV/AIDS and tuberculosis',
    cause_297: 'Tuberculosis',
    cause_298: 'HIV/AIDS',
    cause_300: 'HIV/AIDS resulting in other diseases',
    cause_301: 'Diarrhea, lower respiratory, and other common infectious disease',
    cause_302: 'Diarrheal diseases',
    cause_318: 'Intestinal infectious diseases',
    cause_319: 'Typhoid fever',
    cause_320: 'Paratyphoid fever',
    cause_321: 'Other intestinal infectious diseases',
    cause_322: 'Lower respiratory infections',
    cause_328: 'Upper respiratory infections',
    cause_329: 'Otitis media',
    cause_332: 'Meningitis',
    cause_333: 'Pneumococcal meningitis',
    cause_334: 'H influenzae type B meningitis',
    cause_335: 'Meningococcal meningitis',
    cause_336: 'Other meningitis',
    cause_337: 'Encephalitis',
    cause_338: 'Diphtheria',
    cause_339: 'Whooping cough',
    cause_340: 'Tetanus',
    cause_341: 'Measles',
    cause_342: 'Varicella and herpes zoster',
    cause_344: 'Neglected tropical diseases and malaria',
    cause_345: 'Malaria',
    cause_346: 'Chagas disease',
    cause_347: 'Leishmaniasis',
    cause_348: 'Visceral leishmaniasis',
    cause_349: 'Cutaneous and mucocutaneous leishmaniasis',
    cause_350: 'African trypanosomiasis',
    cause_351: 'Schistosomiasis',
    cause_352: 'Cysticercosis',
    cause_353: 'Cystic echinococcosis',
    cause_354: 'Lymphatic filariasis',
    cause_355: 'Onchocerciasis',
    cause_356: 'Trachoma',
    cause_357: 'Dengue',
    cause_358: 'Yellow fever',
    cause_359: 'Rabies',
    cause_360: 'Intestinal nematode infections',
    cause_361: 'Ascariasis',
    cause_362: 'Trichuriasis',
    cause_363: 'Hookworm disease',
    cause_364: 'Food-borne trematodiases',
    cause_365: 'Other neglected tropical diseases',
    cause_366: 'Maternal disorders',
    cause_367: 'Maternal hemorrhage',
    cause_368: 'Maternal sepsis and other maternal infections',
    cause_369: 'Maternal hypertensive disorders',
    cause_370: 'Maternal obstructed labor and uterine rupture',
    cause_371: 'Maternal abortion, miscarriage, and ectopic pregnancy',
    cause_375: 'Indirect maternal deaths',
    cause_376: 'Late maternal deaths',
    cause_379: 'Other maternal disorders',
    cause_380: 'Neonatal disorders',
    cause_381: 'Neonatal preterm birth complications',
    cause_382: 'Neonatal encephalopathy due to birth asphyxia and trauma',
    cause_383: 'Neonatal sepsis and other neonatal infections',
    cause_384: 'Hemolytic disease and other neonatal jaundice',
    cause_385: 'Other neonatal disorders',
    cause_386: 'Nutritional deficiencies',
    cause_387: 'Protein-energy malnutrition',
    cause_388: 'Iodine deficiency',
    cause_389: 'Vitamin A deficiency',
    cause_390: 'Iron-deficiency anemia',
    cause_391: 'Other nutritional deficiencies',
    cause_392: 'Other communicable, maternal, neonatal, and nutritional diseases',
    cause_393: 'Sexually transmitted diseases excluding HIV',
    cause_394: 'Syphilis',
    cause_395: 'Chlamydial infection',
    cause_396: 'Gonococcal infection',
    cause_397: 'Trichomoniasis',
    cause_398: 'Genital herpes',
    cause_399: 'Other sexually transmitted diseases',
    cause_400: 'Acute hepatitis',
    cause_401: 'Acute hepatitis A',
    cause_402: 'Acute hepatitis B',
    cause_403: 'Acute hepatitis C',
    cause_404: 'Acute hepatitis E',
    cause_405: 'Leprosy',
    cause_408: 'Other infectious diseases',
    cause_409: 'Non-communicable diseases',
    cause_410: 'Neoplasms',
    cause_411: 'Esophageal cancer',
    cause_414: 'Stomach cancer',
    cause_417: 'Liver cancer',
    cause_418: 'Liver cancer due to hepatitis B',
    cause_419: 'Liver cancer due to hepatitis C',
    cause_420: 'Liver cancer due to alcohol use',
    cause_421: 'Liver cancer due to other causes',
    cause_423: 'Larynx cancer',
    cause_426: 'Tracheal, bronchus, and lung cancer',
    cause_429: 'Breast cancer',
    cause_432: 'Cervical cancer',
    cause_435: 'Uterine cancer',
    cause_438: 'Prostate cancer',
    cause_441: 'Colon and rectum cancer',
    cause_444: 'Lip and oral cavity cancer',
    cause_447: 'Nasopharynx cancer',
    cause_450: 'Other pharynx cancer',
    cause_453: 'Gallbladder and biliary tract cancer',
    cause_456: 'Pancreatic cancer',
    cause_459: 'Malignant skin melanoma',
    cause_462: 'Non-melanoma skin cancer',
    cause_465: 'Ovarian cancer',
    cause_468: 'Testicular cancer',
    cause_471: 'Kidney cancer',
    cause_474: 'Bladder cancer',
    cause_477: 'Brain and nervous system cancer',
    cause_480: 'Thyroid cancer',
    cause_483: 'Mesothelioma',
    cause_484: 'Hodgkin lymphoma',
    cause_485: 'Non-Hodgkin lymphoma',
    cause_486: 'Multiple myeloma',
    cause_487: 'Leukemia',
    cause_488: 'Other neoplasms',
    cause_491: 'Cardiovascular diseases',
    cause_492: 'Rheumatic heart disease',
    cause_493: 'Ischemic heart disease',
    cause_494: 'Cerebrovascular disease',
    cause_495: 'Ischemic stroke',
    cause_496: 'Hemorrhagic stroke',
    cause_498: 'Hypertensive heart disease',
    cause_499: 'Cardiomyopathy and myocarditis',
    cause_500: 'Atrial fibrillation and flutter',
    cause_501: 'Aortic aneurysm',
    cause_502: 'Peripheral artery disease',
    cause_503: 'Endocarditis',
    cause_507: 'Other cardiovascular and circulatory diseases',
    cause_508: 'Chronic respiratory diseases',
    cause_509: 'Chronic obstructive pulmonary disease',
    cause_510: 'Pneumoconiosis',
    cause_511: 'Silicosis',
    cause_512: 'Asbestosis',
    cause_513: 'Coal workers pneumoconiosis',
    cause_514: 'Other pneumoconiosis',
    cause_515: 'Asthma',
    cause_516: 'Interstitial lung disease and pulmonary sarcoidosis',
    cause_520: 'Other chronic respiratory diseases',
    cause_521: 'Cirrhosis and other chronic liver diseases',
    cause_522: 'Cirrhosis and other chronic liver diseases due to hepatitis B',
    cause_523: 'Cirrhosis and other chronic liver diseases due to hepatitis C',
    cause_524: 'Cirrhosis and other chronic liver diseases due to alcohol use',
    cause_525: 'Cirrhosis and other chronic liver diseases due to other causes',
    cause_526: 'Digestive diseases',
    cause_527: 'Peptic ulcer disease',
    cause_528: 'Gastritis and duodenitis',
    cause_529: 'Appendicitis',
    cause_530: 'Paralytic ileus and intestinal obstruction',
    cause_531: 'Inguinal, femoral, and abdominal hernia',
    cause_532: 'Inflammatory bowel disease',
    cause_533: 'Vascular intestinal disorders',
    cause_534: 'Gallbladder and biliary diseases',
    cause_535: 'Pancreatitis',
    cause_541: 'Other digestive diseases',
    cause_542: 'Neurological disorders',
    cause_543: 'Alzheimer disease and other dementias',
    cause_544: 'Parkinson disease',
    cause_545: 'Epilepsy',
    cause_546: 'Multiple sclerosis',
    cause_547: 'Migraine',
    cause_548: 'Tension-type headache',
    cause_554: 'Motor neuron disease',
    cause_557: 'Other neurological disorders',
    cause_558: 'Mental and substance use disorders',
    cause_559: 'Schizophrenia',
    cause_560: 'Alcohol use disorders',
    cause_561: 'Drug use disorders',
    cause_562: 'Opioid use disorders',
    cause_563: 'Cocaine use disorders',
    cause_564: 'Amphetamine use disorders',
    cause_565: 'Cannabis use disorders',
    cause_566: 'Other drug use disorders',
    cause_567: 'Depressive disorders',
    cause_568: 'Major depressive disorder',
    cause_569: 'Dysthymia',
    cause_570: 'Bipolar disorder',
    cause_571: 'Anxiety disorders',
    cause_572: 'Eating disorders',
    cause_573: 'Anorexia nervosa',
    cause_574: 'Bulimia nervosa',
    cause_575: 'Autistic spectrum disorders',
    cause_576: 'Autism',
    cause_577: 'Asperger syndrome and other autistic spectrum disorders',
    cause_578: 'Attention-deficit/hyperactivity disorder',
    cause_579: 'Conduct disorder',
    cause_582: 'Idiopathic developmental intellectual disability',
    cause_585: 'Other mental and substance use disorders',
    cause_586: 'Diabetes, urogenital, blood, and endocrine diseases',
    cause_587: 'Diabetes mellitus',
    cause_588: 'Acute glomerulonephritis',
    cause_589: 'Chronic kidney disease',
    cause_590: 'Chronic kidney disease due to diabetes mellitus',
    cause_591: 'Chronic kidney disease due to hypertension',
    cause_592: 'Chronic kidney disease due to glomerulonephritis',
    cause_593: 'Chronic kidney disease due to other causes',
    cause_594: 'Urinary diseases and male infertility',
    cause_595: 'Interstitial nephritis and urinary tract infections',
    cause_596: 'Urolithiasis',
    cause_597: 'Benign prostatic hyperplasia',
    cause_598: 'Male infertility',
    cause_602: 'Other urinary diseases',
    cause_603: 'Gynecological diseases',
    cause_604: 'Uterine fibroids',
    cause_605: 'Polycystic ovarian syndrome',
    cause_606: 'Female infertility',
    cause_607: 'Endometriosis',
    cause_608: 'Genital prolapse',
    cause_609: 'Premenstrual syndrome',
    cause_612: 'Other gynecological diseases',
    cause_613: 'Hemoglobinopathies and hemolytic anemias',
    cause_614: 'Thalassemias',
    cause_615: 'Sickle cell disorders',
    cause_616: 'G6PD deficiency',
    cause_618: 'Other hemoglobinopathies and hemolytic anemias',
    cause_619: 'Endocrine, metabolic, blood, and immune disorders',
    cause_626: 'Musculoskeletal disorders',
    cause_627: 'Rheumatoid arthritis',
    cause_628: 'Osteoarthritis',
    cause_629: 'Low back and neck pain',
    cause_630: 'Low back pain',
    cause_631: 'Neck pain',
    cause_632: 'Gout',
    cause_639: 'Other musculoskeletal disorders',
    cause_640: 'Other non-communicable diseases',
    cause_641: 'Congenital birth defects',
    cause_642: 'Neural tube defects',
    cause_643: 'Congenital heart anomalies',
    cause_644: 'Orofacial clefts',
    cause_645: 'Down syndrome',
    cause_646: 'Turner syndrome',
    cause_647: 'Klinefelter syndrome',
    cause_648: 'Other chromosomal abnormalities',
    cause_649: 'Congenital musculoskeletal and limb anomalies',
    cause_650: 'Urogenital congenital anomalies',
    cause_651: 'Digestive congenital anomalies',
    cause_652: 'Other congenital birth defects',
    cause_653: 'Skin and subcutaneous diseases',
    cause_654: 'Dermatitis',
    cause_655: 'Psoriasis',
    cause_656: 'Cellulitis',
    cause_657: 'Pyoderma',
    cause_658: 'Scabies',
    cause_659: 'Fungal skin diseases',
    cause_660: 'Viral skin diseases',
    cause_661: 'Acne vulgaris',
    cause_662: 'Alopecia areata',
    cause_663: 'Pruritus',
    cause_664: 'Urticaria',
    cause_665: 'Decubitus ulcer',
    cause_668: 'Other skin and subcutaneous diseases',
    cause_669: 'Sense organ diseases',
    cause_670: 'Glaucoma',
    cause_671: 'Cataract',
    cause_672: 'Macular degeneration',
    cause_673: 'Refraction and accommodation disorders',
    cause_674: 'Age-related and other hearing loss',
    cause_675: 'Other vision loss',
    cause_679: 'Other sense organ diseases',
    cause_680: 'Oral disorders',
    cause_681: 'Caries of deciduous teeth',
    cause_682: 'Caries of permanent teeth',
    cause_683: 'Periodontal diseases',
    cause_684: 'Edentulism and severe tooth loss',
    cause_685: 'Other oral disorders',
    cause_686: 'Sudden infant death syndrome',
    cause_687: 'Injuries',
    cause_688: 'Transport injuries',
    cause_689: 'Road injuries',
    cause_690: 'Pedestrian road injuries',
    cause_691: 'Cyclist road injuries',
    cause_692: 'Motorcyclist road injuries',
    cause_693: 'Motor vehicle road injuries',
    cause_694: 'Other road injuries',
    cause_695: 'Other transport injuries',
    cause_696: 'Unintentional injuries',
    cause_697: 'Falls',
    cause_698: 'Drowning',
    cause_699: 'Fire, heat, and hot substances',
    cause_700: 'Poisonings',
    cause_704: 'Exposure to mechanical forces',
    cause_705: 'Unintentional firearm injuries',
    cause_706: 'Unintentional suffocation',
    cause_707: 'Other exposure to mechanical forces',
    cause_708: 'Adverse effects of medical treatment',
    cause_709: 'Animal contact',
    cause_710: 'Venomous animal contact',
    cause_711: 'Non-venomous animal contact',
    cause_712: 'Foreign body',
    cause_713: 'Pulmonary aspiration and foreign body in airway',
    cause_714: 'Foreign body in eyes',
    cause_715: 'Foreign body in other body part',
    cause_716: 'Other unintentional injuries',
    cause_717: 'Self-harm and interpersonal violence',
    cause_718: 'Self-harm',
    cause_721: 'Self-harm by firearm',
    cause_723: 'Self-harm by other specified means',
    cause_724: 'Interpersonal violence',
    cause_725: 'Physical violence by firearm',
    cause_726: 'Physical violence by sharp object',
    cause_727: 'Physical violence by other means',
    cause_728: 'Forces of nature, conflict and terrorism, and executions and pol',
    cause_729: 'Exposure to forces of nature',
    cause_740: 'None',
    cause_741: 'Maternal deaths aggravated by HIV/AIDS',
    cause_837: 'Thalassemias trait',
    cause_838: 'Sickle cell trait',
    cause_839: 'G6PD trait',
    cause_842: 'Environmental heat and cold exposure',
    cause_843: 'Ebola',
    cause_845: 'Acute lymphoid leukemia',
    cause_846: 'Chronic lymphoid leukemia',
    cause_847: 'Acute myeloid leukemia',
    cause_848: 'Chronic myeloid leukemia',
    cause_849: 'Non-melanoma skin cancer (squamous-cell carcinoma)',
    cause_850: 'Non-melanoma skin cancer (basal-cell carcinoma)',
    cause_854: 'Executions and police conflict',
    cause_934: 'Drug-susceptible tuberculosis',
    cause_935: 'Zika virus',
    cause_936: 'Guinea worm disease',
    cause_938: 'Alcoholic cardiomyopathy',
    cause_941: 'Sexual violence',
    cause_942: 'Myocarditis',
    cause_943: 'Other leukemia',
    cause_944: 'Other cardiomyopathy',
    cause_945: 'Conflict and terrorism',
    cause_946: 'Multidrug-resistant tuberculosis without extensive drug resistan',
    cause_947: 'Extensively drug-resistant tuberculosis',
    cause_948: 'Drug-susceptible HIV/AIDS - Tuberculosis',
    cause_949: 'Multidrug-resistant HIV/AIDS - Tuberculosis without extensive dr',
    cause_950: 'Extensively drug-resistant HIV/AIDS - Tuberculosis',
    cause_954: 'Latent tuberculosis infection',
    'cause_400,418,419,522,523': 'Hepatitis',
    'cause_402,418,522': 'Hepatitis B',
    'cause_403,419,523': 'Hepatitis C',

    location_1: 'Global',
    location_4: 'Southeast Asia, East Asia, and Oceania',
    location_5: 'East Asia',
    location_6: 'China',
    location_7: 'Dem. Rep. Korea',
    location_8: 'Taiwan',
    location_9: 'Southeast Asia',
    location_10: 'Cambodia',
    location_11: 'Indonesia',
    location_12: 'Laos',
    location_13: 'Malaysia',
    location_14: 'Maldives',
    location_15: 'Myanmar',
    location_16: 'Philippines',
    location_17: 'Sri Lanka',
    location_18: 'Thailand',
    location_19: 'Timor-Leste',
    location_20: 'Vietnam',
    location_21: 'Oceania',
    location_22: 'Fiji',
    location_23: 'Kiribati',
    location_24: 'Marshall Islands',
    location_25: 'Federated States of Micronesia',
    location_26: 'Papua New Guinea',
    location_27: 'Samoa',
    location_28: 'Solomon Is.',
    location_29: 'Tonga',
    location_30: 'Vanuatu',
    location_31: 'Central Europe, Eastern Europe, and Central Asia',
    location_32: 'Central Asia',
    location_33: 'Armenia',
    location_34: 'Azerbaijan',
    location_35: 'Georgia',
    location_36: 'Kazakhstan',
    location_37: 'Kyrgyzstan',
    location_38: 'Mongolia',
    location_39: 'Tajikistan',
    location_40: 'Turkmenistan',
    location_41: 'Uzbekistan',
    location_42: 'Central Europe',
    location_43: 'Albania',
    location_44: 'Bosnia and Herzegovina',
    location_45: 'Bulgaria',
    location_46: 'Croatia',
    location_47: 'Czech Rep.',
    location_48: 'Hungary',
    location_49: 'Macedonia',
    location_50: 'Montenegro',
    location_51: 'Poland',
    location_52: 'Romania',
    location_53: 'Serbia',
    location_54: 'Slovakia',
    location_55: 'Slovenia',
    location_56: 'Eastern Europe',
    location_57: 'Belarus',
    location_58: 'Estonia',
    location_59: 'Latvia',
    location_60: 'Lithuania',
    location_61: 'Moldova',
    location_62: 'Russia',
    location_63: 'Ukraine',
    location_64: 'High-income',
    location_65: 'High-income Asia Pacific',
    location_66: 'Brunei',
    location_67: 'Japan',
    location_68: 'Korea',
    location_69: 'Singapore',
    location_70: 'Australasia',
    location_71: 'Australia',
    location_72: 'New Zealand',
    location_73: 'Western Europe',
    location_74: 'Andorra',
    location_75: 'Austria',
    location_76: 'Belgium',
    location_77: 'Cyprus',
    location_78: 'Denmark',
    location_79: 'Finland',
    location_80: 'France',
    location_81: 'Germany',
    location_82: 'Greece',
    location_83: 'Iceland',
    location_84: 'Ireland',
    location_85: 'Israel',
    location_86: 'Italy',
    location_87: 'Luxembourg',
    location_88: 'Malta',
    location_89: 'Netherlands',
    location_90: 'Norway',
    location_91: 'Portugal',
    location_92: 'Spain',
    location_93: 'Sweden',
    location_94: 'Switzerland',
    location_95: 'United Kingdom',
    location_96: 'Southern Latin America',
    location_97: 'Argentina',
    location_98: 'Chile',
    location_99: 'Uruguay',
    location_100: 'High-income North America',
    location_101: 'Canada',
    location_102: 'United States',
    location_103: 'Latin America and Caribbean',
    location_104: 'Caribbean',
    location_105: 'Antigua and Barbuda',
    location_106: 'The Bahamas',
    location_107: 'Barbados',
    location_108: 'Belize',
    location_109: 'Cuba',
    location_110: 'Dominica',
    location_111: 'Dominican Republic',
    location_112: 'Grenada',
    location_113: 'Guyana',
    location_114: 'Haiti',
    location_115: 'Jamaica',
    location_116: 'Saint Lucia',
    location_117: 'Saint Vincent and the Grenadines',
    location_118: 'Suriname',
    location_119: 'Trinidad and Tobago',
    location_120: 'Andean Latin America',
    location_121: 'Bolivia',
    location_122: 'Ecuador',
    location_123: 'Peru',
    location_124: 'Central Latin America',
    location_125: 'Colombia',
    location_126: 'Costa Rica',
    location_127: 'El Salvador',
    location_128: 'Guatemala',
    location_129: 'Honduras',
    location_130: 'Mexico',
    location_131: 'Nicaragua',
    location_132: 'Panama',
    location_133: 'Venezuela',
    location_134: 'Tropical Latin America',
    location_135: 'Brazil',
    location_136: 'Paraguay',
    location_137: 'North Africa and Middle East',
    location_138: 'North Africa and Middle East',
    location_139: 'Algeria',
    location_140: 'Bahrain',
    location_141: 'Egypt',
    location_142: 'Iran',
    location_143: 'Iraq',
    location_144: 'Jordan',
    location_145: 'Kuwait',
    location_146: 'Lebanon',
    location_147: 'Libya',
    location_148: 'Morocco',
    location_149: 'Palestine',
    location_150: 'Oman',
    location_151: 'Qatar',
    location_152: 'Saudi Arabia',
    location_153: 'Syria',
    location_154: 'Tunisia',
    location_155: 'Turkey',
    location_156: 'United Arab Emirates',
    location_157: 'Yemen',
    location_158: 'South Asia',
    location_159: 'South Asia',
    location_160: 'Afghanistan',
    location_161: 'Bangladesh',
    location_162: 'Bhutan',
    location_163: 'India',
    location_164: 'Nepal',
    location_165: 'Pakistan',
    location_166: 'Sub-Saharan Africa',
    location_167: 'Central Sub-Saharan Africa',
    location_168: 'Angola',
    location_169: 'Central African Rep.',
    location_170: 'Congo',
    location_171: 'Dem. Rep. Congo',
    location_172: 'Eq. Guinea',
    location_173: 'Gabon',
    location_174: 'Eastern Sub-Saharan Africa',
    location_175: 'Burundi',
    location_176: 'Comoros',
    location_177: 'Djibouti',
    location_178: 'Eritrea',
    location_179: 'Ethiopia',
    location_180: 'Kenya',
    location_181: 'Madagascar',
    location_182: 'Malawi',
    location_183: 'Mauritius',
    location_184: 'Mozambique',
    location_185: 'Rwanda',
    location_186: 'Seychelles',
    location_187: 'Somalia',
    location_189: 'Tanzania',
    location_190: 'Uganda',
    location_191: 'Zambia',
    location_192: 'Southern Sub-Saharan Africa',
    location_193: 'Botswana',
    location_194: 'Lesotho',
    location_195: 'Namibia',
    location_196: 'South Africa',
    location_197: 'Swaziland',
    location_198: 'Zimbabwe',
    location_199: 'Western Sub-Saharan Africa',
    location_200: 'Benin',
    location_201: 'Burkina Faso',
    location_202: 'Cameroon',
    location_203: 'Cape Verde',
    location_204: 'Chad',
    location_205: "Côte d'Ivoire",
    location_206: 'The Gambia',
    location_207: 'Ghana',
    location_208: 'Guinea',
    location_209: 'Guinea-Bissau',
    location_210: 'Liberia',
    location_211: 'Mali',
    location_212: 'Mauritania',
    location_213: 'Niger',
    location_214: 'Nigeria',
    location_215: 'Sao Tome and Principe',
    location_216: 'Senegal',
    location_217: 'Sierra Leone',
    location_218: 'Togo',
    location_298: 'American Samoa',
    location_305: 'Bermuda',
    location_349: 'Greenland',
    location_351: 'Guam',
    location_376: 'Northern Mariana Islands',
    location_385: 'Puerto Rico',
    location_422: 'Virgin Islands, U.S.',
    location_433: 'Northern Ireland',
    location_434: 'Scotland',
    location_435: 'S. Sudan',
    location_522: 'Sudan',
    location_4618: 'North East England',
    location_4619: 'North West England',
    location_4620: 'Yorkshire and the Humber',
    location_4621: 'East Midlands',
    location_4622: 'West Midlands',
    location_4623: 'East of England',
    location_4624: 'Greater London',
    location_4625: 'South East England',
    location_4626: 'South West England',
    location_4636: 'Wales',
    location_4643: 'Aguascalientes',
    location_4644: 'Baja California',
    location_4645: 'Baja California Sur',
    location_4646: 'Campeche',
    location_4647: 'Coahuila',
    location_4648: 'Colima',
    location_4649: 'Chiapas',
    location_4650: 'Chihuahua',
    location_4651: 'Distrito Federal',
    location_4652: 'Durango',
    location_4653: 'Guanajuato',
    location_4654: 'Guerrero',
    location_4655: 'Hidalgo',
    location_4656: 'Jalisco',
    location_4657: 'México',
    location_4658: 'Michoacán de Ocampo',
    location_4659: 'Morelos',
    location_4660: 'Nayarit',
    location_4661: 'Nuevo León',
    location_4662: 'Oaxaca',
    location_4663: 'Puebla',
    location_4664: 'Querétaro',
    location_4665: 'Quintana Roo',
    location_4666: 'San Luis Potosí',
    location_4667: 'Sinaloa',
    location_4668: 'Sonora',
    location_4669: 'Tabasco',
    location_4670: 'Tamaulipas',
    location_4671: 'Tlaxcala',
    location_4672: 'Veracruz de Ignacio de la Llave',
    location_4673: 'Yucatán',
    location_4674: 'Zacatecas',
    location_4749: 'England',
    location_4940: 'Sweden except Stockholm',
    location_4944: 'Stockholm',
    location_35424: 'Hokkaidō',
    location_35425: 'Aomori',
    location_35426: 'Iwate',
    location_35427: 'Miyagi',
    location_35428: 'Akita',
    location_35429: 'Yamagata',
    location_35430: 'Fukushima',
    location_35431: 'Ibaraki',
    location_35432: 'Tochigi',
    location_35433: 'Gunma',
    location_35434: 'Saitama',
    location_35435: 'Chiba',
    location_35436: 'Tōkyō',
    location_35437: 'Kanagawa',
    location_35438: 'Niigata',
    location_35439: 'Toyama',
    location_35440: 'Ishikawa',
    location_35441: 'Fukui',
    location_35442: 'Yamanashi',
    location_35443: 'Nagano',
    location_35444: 'Gifu',
    location_35445: 'Shizuoka',
    location_35446: 'Aichi',
    location_35447: 'Mie',
    location_35448: 'Shiga',
    location_35449: 'Kyōto',
    location_35450: 'Ōsaka',
    location_35451: 'Hyōgo',
    location_35452: 'Nara',
    location_35453: 'Wakayama',
    location_35454: 'Tottori',
    location_35455: 'Shimane',
    location_35456: 'Okayama',
    location_35457: 'Hiroshima',
    location_35458: 'Yamaguchi',
    location_35459: 'Tokushima',
    location_35460: 'Kagawa',
    location_35461: 'Ehime',
    location_35462: 'Kōchi',
    location_35463: 'Fukuoka',
    location_35464: 'Saga',
    location_35465: 'Nagasaki',
    location_35466: 'Kumamoto',
    location_35467: 'Ôita',
    location_35468: 'Miyazaki',
    location_35469: 'Kagoshima',
    location_35470: 'Okinawa',
    location_44634: 'High-middle SDI',
    location_44635: 'High SDI',
    location_44636: 'Low-middle SDI',
    location_44637: 'Low SDI',
    location_44639: 'Middle SDI',

    sequela_862: 'Asymptomatic acute hepatitis A',
    sequela_863: 'Asymptomatic acute hepatitis B',
    sequela_864: 'Asymptomatic acute hepatitis C',
    sequela_865: 'Asymptomatic acute hepatitis E',
    sequela_902: 'Chronic Hepatitis B',
    sequela_903: 'Chronic Hepatitis C',
    sequela_5135: 'Cirrhosis and other chronic liver diseases due to hepatitis B, compensated',
    sequela_835: 'Cirrhosis and other chronic liver diseases due to hepatitis B, decompensated',
    sequela_5138: 'Cirrhosis and other chronic liver diseases due to hepatitis C, compensated',
    sequela_836: 'Cirrhosis and other chronic liver diseases due to hepatitis C, decompensated',
    sequela_253: 'Controlled phase of liver cancer due to hepatitis B',
    sequela_257: 'Controlled phase of liver cancer due to hepatitis C',
    sequela_252: 'Diagnosis and primary therapy phase of liver cancer due to hepatitis B',
    sequela_256: 'Diagnosis and primary therapy phase of liver cancer due to hepatitis C',
    sequela_254: 'Metastatic phase of liver cancer due to hepatitis B',
    sequela_258: 'Metastatic phase of liver cancer due to hepatitis C',
    sequela_229: 'Moderate acute hepatitis A',
    sequela_231: 'Moderate acute hepatitis B',
    sequela_233: 'Moderate acute hepatitis C',
    sequela_235: 'Moderate acute hepatitis E',
    sequela_230: 'Severe acute hepatitis A',
    sequela_232: 'Severe acute hepatitis B',
    sequela_234: 'Severe acute hepatitis C',
    sequela_236: 'Severe acute hepatitis E',
    sequela_255: 'Terminal phase of liver cancer due to hepatitis B',
    sequela_259: 'Terminal phase of liver cancer due to hepatitis C',

    forecast_scenario_1: 'Reference',
    forecast_scenario_2: 'Better',
    forecast_scenario_3: 'Worse',
    'forecast_scenario_1,2,3': 'All Forecast Scenarios',

    filter_age_group_title: 'Age:',
    filter_gender_title: 'Gender:',
    filter_measure_title: 'Measure:',
    filter_metric_title: 'Unit:',
    filter_cause_title: 'Cause:',
    filter_location_title: 'Location:',
    filter_forecast_scenario_title: 'Scenarios',

    filter_label_age_group_id: 'Age',
    filter_label_gender_id: 'Gender',
    filter_label_measure_id: 'Measure',
    filter_scenario_label: 'Scenario',
    filter_label_metric_id: 'Unit',
    filter_label_cause_id: 'Cause',
    filter_label_age: 'Age',
    filter_label_age_group_name: 'Age',
    filter_label_sequela_id: 'Sequela',
    filter_label_rei_id: 'REI',
    filter_label_covariate_id: 'Covariate',
    filter_label_sdoh_id: 'SDoH',
    filter_label_location_id: 'Location',
    filter_label_forecast_scenario_id: 'Scenarios',
    filter_label_year: 'Year',
    filter_label_value: 'Value',
    filter_label_upper: 'Upper',
    filter_label_lower: 'Lower',
    filter_label_rank: '#',
    filter_label_cro_id: 'Granular Resolution',

    toggle_charts_visibility_button_label: 'Visualizations',
    chart_reset_button_label: 'Reset',
    chart_save_as_image_button_label: 'Save as image',
    chart_save_as_csv_button_label: 'Save as CSV',
    chart_save_as_gif_button_label: 'Save as GIF',
    map_chart_zoom_controls_label: 'Zoom In/Out:',
    map_chart_zoom_in: 'Zoom In',
    map_chart_zoom_out: 'Zoom Out',
    map_chart_reset_zoom: 'Reset zoom',
    map_chart_set_scale: 'Set Scale',
    map_chart_reset_scale: 'Reset',

    chart_error_no_data: 'No data available',
    data_table_error_no_data: 'No data available',
    data_table_error_no_search_results: 'No matching results found.',

    error_field_cant_be_empty: `%field% can't be empty`,
    error_field_should_not_exceed_maximum_characters: '%field% should not exceed %max% characters',
    error_field_should_be_minimum_characters: '%field% should be at least %min% characters long',
    error_invalid_email_format: 'Invalid email format',
    error_pasted_text_was_cropped: 'Pasted text was cropped due to %max% characters limit',

    pdf_report_modal_title_label: 'Report Title',
    pdf_report_modal_subtitle_label: 'Report Subtitle',
    pdf_report_modal_description_label: 'Description',
    pdf_generating_label: 'Please wait, PDF file is being generated...',
    pdf_saving_label: 'Almost done, saving the PDF file...',

    survey_progress_title: 'Question %question%/%total%',
    survey_status_dismissed: 'Dismissed',
    survey_status_responded: 'Responded',
    please_specify: 'Please specify',

    show_less_options: 'Show less',
    show_all_options: 'Show all %total% items',

    pagination_first_page: 'First',
    pagination_last_page: 'Last',
    pagination_enter_page: 'Enter page',
    pagination_page_number_of_total: 'Page %page% of %total%',
};
